import { render } from "./TpvFloatingControls.vue?vue&type=template&id=95673a24&scoped=true"
import script from "./TpvFloatingControls.vue?vue&type=script&lang=js"
export * from "./TpvFloatingControls.vue?vue&type=script&lang=js"

import "./TpvFloatingControls.vue?vue&type=style&index=0&id=95673a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95673a24"]])

export default __exports__